import { render, staticRenderFns } from "./sfBtm.vue?vue&type=template&id=0d6c69ce&scoped=true&"
import script from "./sfBtm.vue?vue&type=script&lang=js&"
export * from "./sfBtm.vue?vue&type=script&lang=js&"
import style0 from "./sfBtm.vue?vue&type=style&index=0&id=0d6c69ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c69ce",
  null
  
)

export default component.exports